import { api } from '@/core/helpers/axiosHelper';

export default {
    async get({ company_id }: { company_id: number }) {
        return await api
            .get('/department', {
                params: {
                    'filter[company_id]': company_id,
                },
            })
            .then((response) => response.data);
    },
};
